import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {
  IPaging,
  FailResponseObject,
  SuccessResponseObject,
  IPagingSort
} from '../shared';

export class Status {
  label: string;
  statusId: number;
  description: string;
  includes: number[];
  profile?: boolean;
}

@Injectable()
export class IdeaService {
  /**
   *
   */
  static readonly statusText = {
    '2': 'ახალი',
    '3': 'მიმდინარე',
    '4': 'დაბლოკილი',
    '5': 'დაბლოკილი / გამოქვეყნებული',
    '6': 'დასრულებული',
    '7': 'განუხილველი',
    '8': 'განხილვის პროცესში',
    '9': 'განხილვამდე უარყოფილი',
    '10': 'უარყოფილი',
    '11': 'ხარვეზი',
    '12': 'შესწორებული',
    '13': 'განხილული',
    '14': 'მერის თანხმობა',
    '15': 'შეთანხმებული',
    '16': 'მერის უარყოფა',
    '17': 'უარყოფილი',
    '-2': 'განხილვის პროცესში / ვადაგადაცილებული',
    '-3': 'მიმდინარე / ვადაგადაცილებული',
    '-6': 'დასრულებული / ვადაგადაცილებული',
    '-8': 'განხილვის პროცესში / ვადაგადაცილებული',
    '-9': 'განხილვამდე უარყოფილი / ვადაგადაცილებული',
    '-11': 'ხარვეზი / ვადაგადაცილებული',
    '-12': 'შესწორებული / ვადაგადაცილებული',
    '-13': 'განხილული / ვადაგადაცილებული',
    '-14': 'მერის თანხმობა / ვადაგადაცილებული',
    '-16': 'მერის უარყოფა / ვადაგადაცილებული'
  };

  /**
   *
   */
  static readonly statusColor = {
    '2': '#13559A', // "ახალი"
    '3': '#EA7842', // "მიმდინარე"
    '4': '#B92D00', // "დაბლოკილი"
    '5': '#B92D00', // "დაბლოკილი / გამოქვეყნებული"
    '6': '#EA7842', // "დასრულებული"
    '7': '#B92D00', // "განუხილველი"
    '8': '#EA7842', // "განხილვის პროცესში"
    '9': '#B92D00', // "განხილვამდე უარყოფილი"
    '10': '#B92D00', // "უარყოფილი"
    '11': '#B92D00', // "ხარვეზი"
    '12': '#B92D00', // "შესწორებული"
    '13': '#EA7842', // "განხილული"
    '14': '#4CAF50', // "მერის თანხმობა"
    '15': '#4CAF50', // "შეთანხმებული"
    '16': '#B92D00', // "მერის უარყოფა"
    '17': '#B92D00', // "უარყოფილი"
    '-2': '#EA7842', // "განხილვის პროცესში / ვადაგადაცილებული"
    '-3': '#EA7842', // "მიმდინარე / ვადაგადაცილებული"
    '-6': '#EA7842', // "დასრულებული / ვადაგადაცილებული"
    '-8': '#EA7842', // "განხილვის პროცესში / ვადაგადაცილებული"
    '-9': '#B92D00', // "განხილვამდე უარყოფილი / ვადაგადაცილებული"
    '-11': '#B92D00', // "ხარვეზი / ვადაგადაცილებული"
    '-12': '#B92D00', // "შესწორებული / ვადაგადაცილებული"
    '-13': '#EA7842', // "განხილული / ვადაგაცილებული"
    '-14': '#4CAF50', // "მერის თანხმობა / ვადაგადაცილებული
    '-16': '#B92D00' // "მერის უარყოფა / ვადაგადაცილებული"
  };

  /**
   *
   */
  static readonly statuses: Status[] = [
    {
      label: 'რეგისტრირებული',
      statusId: 2,
      description:
        'იდეები, რომლებიც დარეგისტრირებულია, თუმცა ჯერ ხმის მიცემის ეტაპზე არ გადასულა',
      includes: [12],
      profile: true
    },
    {
      label: 'მიმდინარე',
      statusId: 3,
      description: 'იდეები, რომლებიც გადავიდა ხმის მიცემის ეტაპზე',
      includes: [-3]
    },
    {
      label: 'განხილვის პროცესში',
      statusId: 8,
      description:
        'იდეები, რომლებიც გადავიდა გადაწყვეტილების მიღების საბოლოო ეტაპზე',
      includes: [14, 16, 6, 13, -2, -6, -8, -16, -14, -13]
    },
    {
      label: 'შეთანხმებული',
      statusId: 15,
      description:
        'იდეები, რომლებმაც საკმარისი ხმა მოაგროვა და თანხმობა ეთქვა განხორციელებაზე',
      includes: []
    },
    {
      label: 'უარყოფილი',
      statusId: 17,
      description:
        'იდეები, რომლებმაც საკმარისი ხმა მოაგროვა, თუმცა უარი ეთქვა განხორციელებაზე',
      includes: [10, 9, -9]
    },
    {
      label: 'არშემდგარი',
      statusId: 7,
      description: 'იდეები, რომლებმაც საკმარისი ხმა ვერ მოაგროვა',
      includes: []
    },
    {
      label: 'დაბლოკილი',
      statusId: 5,
      description:
        'იდეები, რომლებიც ვერ გადავიდა ხმის მიცემის ეტაპზე და დაიბლოკა გარკვეული მიზეზით',
      includes: []
    },
    {
      label: 'დახარვეზებული',
      statusId: 11,
      description:
        'იდეები, რომლებიც ვერ გადავიდა ხმის მიცემის ეტაპზე და დაიბლოკა გარკვეული მიზეზით',
      includes: [-12],
      profile: true
    }
  ];

  /**
   * Constructor
   *
   * @param _http
   */
  constructor(private _http: HttpClient) {}

  /**
   *
   * @param formData
   */
  upload(formData: FormData) {
    return this._http.post('/api/fs/file', formData);
  }

  /**
   *
   * @param data
   */
  add(data: { [key: string]: any }) {
    return this._http.post('/api/idea', { data });
  }

  /**
   *
   * @param data
   */
  statusDefectAccepted(data: { [key: string]: any }) {
    return this._http.put(`/api/idea/${data.id}/status/defect/accepted`, {
      data
    });
  }

  /**
   *
   * @param data
   */
  sign(data: { [key: string]: any }) {
    return this._http.post('/api/idea/sign', { data });
  }

  /**
   *
   * @param data
   * @param paging
   */
  signerList(data: { [key: string]: any }, paging?: IPaging) {
    return this._http.post('/api/idea/signers', { data, paging });
  }

  /**
   *
   * @param data
   * @param paging
   */
  searchFull(data: { [key: string]: any } = {}, paging?: IPaging, sort?) {
    return this._http.post('/api/ideas', { data, paging, sort });
  }

  /**
   *
   * @param data
   * @param paging
   */
  categorySearch(data: { [key: string]: any } = {}, paging?: IPaging) {
    return this._http.post('/api/idea/categories', { data, paging });
  }

  /**
   *
   * @param data
   */
  categorySearchWithCounts(data: { [key: string]: any } = {}) {
    return this._http.post('/api/idea/categories/count', {
      data: { ...data, id: data.categoryId }
    });
  }

  /**
   *
   * @param data
   */
  employeeSearchWithCounts(data: { [key: string]: any } = {}) {
    return this._http.post('/api/idea/employees/count', { data });
  }

  /**
   *
   * @param data
   */
  decisionSearch(data: { [key: string]: any } = {}) {
    return this._http.post('/api/idea/decisions', { data });
  }

  /**
   *
   * @param data
   */
  getDeadlines(data: { [key: string]: any } = {}) {
    return this._http.post('/api/idea/deadlines', { data });
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/services/idea.service.ts